var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-withdraw-account",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px; background-color: #f7f6f9;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.wd.withdrawAccount"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", { staticClass: "account-tit" }, [
            _c("div", { staticClass: "account-img" }, [
              _c("img", {
                attrs: { src: _vm._f("imgPath")(_vm.icon), alt: "" },
              }),
            ]),
            _c("span", { staticClass: "line" }),
            _c("div", { staticClass: "account-name" }, [
              _vm._v(_vm._s(_vm.withdrawalMethod)),
            ]),
          ]),
          _c("div", { staticClass: "select" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.cc")))]),
            _c("div", { staticClass: "country" }, [
              _c("img", {
                attrs: { src: _vm._f("imgPath")(_vm.locaFlag), alt: "" },
              }),
              _c("div", { staticClass: "account-name" }, [
                _vm._v(_vm._s(_vm.locaCode)),
              ]),
            ]),
          ]),
          _vm.bankType.includes(_vm.withdrawalMethod)
            ? [
                _vm.locaCode === "ID"
                  ? [
                      _c(
                        "div",
                        { staticClass: "select" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("lang.wd.bankName"))),
                          ]),
                          _c("van-field", {
                            attrs: {
                              "is-link": "",
                              readonly: "",
                              label: "",
                              placeholder: _vm.$t("lang.wd.bankName"),
                            },
                            on: {
                              click: function ($event) {
                                _vm.showBankPicker = true
                              },
                            },
                            model: {
                              value: _vm.bankIndonesiaText,
                              callback: function ($$v) {
                                _vm.bankIndonesiaText = $$v
                              },
                              expression: "bankIndonesiaText",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "select" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.wd.bankAccount"))),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.accountId,
                              expression: "accountId",
                              modifiers: { number: true },
                            },
                          ],
                          attrs: {
                            type: "number",
                            placeholder: _vm.$t("lang.wd.bankAccount"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = _vm._n($event.target.value)
                              },
                              _vm.onlyMaxLengthNumber,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "select" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.wd.accountName"))),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.accountName,
                              expression: "accountName",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "20",
                            placeholder: _vm.$t("lang.wd.phYourName"),
                          },
                          domProps: { value: _vm.accountName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountName = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "select" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.wd.phoneNumber"))),
                        ]),
                        _c("div", { staticClass: "phone-number-wrapper" }, [
                          _c("span", { staticClass: "area-wrapper" }, [
                            _vm._v("+62"),
                          ]),
                          _c("div", { staticClass: "account-line" }),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.userPhoneNumber,
                                expression: "userPhoneNumber",
                                modifiers: { number: true },
                              },
                            ],
                            attrs: {
                              type: "number",
                              placeholder: `${_vm.$t(
                                "lang.wd.phoneNumber"
                              )}（eg：12345678910）`,
                            },
                            domProps: { value: _vm.userPhoneNumber },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.userPhoneNumber = _vm._n(
                                    $event.target.value
                                  )
                                },
                                _vm.onlyMaxLengthPhoneNumber,
                              ],
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "select" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.name")))]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.accountName,
                              expression: "accountName",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.wd.name"),
                          },
                          domProps: { value: _vm.accountName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountName = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "select" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("lang.wd.phAccount"))),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.accountId,
                              expression: "accountId",
                              modifiers: { number: true },
                            },
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "24",
                            placeholder: _vm.$t("lang.wd.accountMlgPh"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = _vm._n($event.target.value)
                              },
                              _vm.onlyNumber,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm.locaCode === "MA"
                        ? _c(
                            "div",
                            { staticClass: "select" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("lang.wd.bankName"))),
                              ]),
                              _c("van-field", {
                                attrs: {
                                  "is-link": "",
                                  readonly: "",
                                  label: "",
                                  placeholder: _vm.$t("lang.wd.bankName"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showBankPicker = true
                                  },
                                },
                                model: {
                                  value: _vm.bankIndonesiaText,
                                  callback: function ($$v) {
                                    _vm.bankIndonesiaText = $$v
                                  },
                                  expression: "bankIndonesiaText",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
              ]
            : _vm.locaCode === "CO" &&
              _vm.withdrawalMethod === "Transfer bancaria"
            ? [
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Nombre del Cliente")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.accountName,
                        expression: "columbiaForm.accountName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: { type: "text", placeholder: "Por favor, rellene" },
                    domProps: { value: _vm.columbiaForm.accountName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "accountName",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Dirección del Cliente")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.accountAddress,
                        expression: "columbiaForm.accountAddress",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: { type: "text", placeholder: "Por favor, rellene" },
                    domProps: { value: _vm.columbiaForm.accountAddress },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "accountAddress",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("span", [_vm._v("Identificación del Cliente")]),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        label: "",
                        placeholder: "Por favor seleccione",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showTypePicker1 = true
                        },
                      },
                      model: {
                        value: _vm.pickerTypeValue1,
                        callback: function ($$v) {
                          _vm.pickerTypeValue1 = $$v
                        },
                        expression: "pickerTypeValue1",
                      },
                    }),
                  ],
                  1
                ),
                _vm.pickerTypeValue1 !== ""
                  ? [
                      _c("div", { staticClass: "select" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.columbiaForm.idNumber,
                              expression: "columbiaForm.idNumber",
                              modifiers: { trim: true },
                            },
                          ],
                          staticStyle: { color: "#333" },
                          attrs: {
                            type: "text",
                            maxlength:
                              _vm.pickerTypeValue1 === "Cédula de Identidad"
                                ? 10
                                : 8,
                            placeholder:
                              _vm.pickerTypeValue1 === "Cédula de Identidad"
                                ? "Por favor, introduzca 10 caracteres"
                                : "Ingrese un máximo de 8 dígitos",
                          },
                          domProps: { value: _vm.columbiaForm.idNumber },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.columbiaForm,
                                "idNumber",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Correo Electrónico del Cliente")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.email,
                        expression: "columbiaForm.email",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: { type: "text", placeholder: "Por favor, rellene" },
                    domProps: { value: _vm.columbiaForm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "email",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Apellido")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.lastName,
                        expression: "columbiaForm.lastName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: { type: "text", placeholder: "Por favor, rellene" },
                    domProps: { value: _vm.columbiaForm.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "lastName",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Teléfono del Cliente")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.phoneNumber,
                        expression: "columbiaForm.phoneNumber",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: {
                      type: "number",
                      placeholder: "Ingrese un máximo de 10 dígitos",
                      maxlength: "10",
                    },
                    domProps: { value: _vm.columbiaForm.phoneNumber },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.columbiaForm,
                            "phoneNumber",
                            $event.target.value.trim()
                          )
                        },
                        (ev) => {
                          _vm.columbiaForm.phoneNumber = ev.target.value.slice(
                            0,
                            10
                          )
                        },
                      ],
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("span", [_vm._v("Tipo de Cuenta")]),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        label: "",
                        placeholder: "Por favor seleccione",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showTypePicker2 = true
                        },
                      },
                      model: {
                        value: _vm.pickerTypeValue2,
                        callback: function ($$v) {
                          _vm.pickerTypeValue2 = $$v
                        },
                        expression: "pickerTypeValue2",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Cuenta")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.accountId,
                        expression: "columbiaForm.accountId",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: {
                      type: "number",
                      placeholder: "Por favor, rellene",
                    },
                    domProps: { value: _vm.columbiaForm.accountId },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "accountId",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("span", [_vm._v("ID del Banco y Nombre del Banco")]),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        label: "",
                        placeholder: _vm.$t("lang.wd.bankName"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.showBankPicker = true
                        },
                      },
                      model: {
                        value: _vm.bankIndonesiaText,
                        callback: function ($$v) {
                          _vm.bankIndonesiaText = $$v
                        },
                        expression: "bankIndonesiaText",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.locaCode === "CO" &&
              _vm.withdrawalMethod === "Transfiya bancaria"
            ? [
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Nombre del Cliente")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.accountName,
                        expression: "columbiaForm.accountName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: { type: "text", placeholder: "Por favor, rellene" },
                    domProps: { value: _vm.columbiaForm.accountName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.columbiaForm,
                          "accountName",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("span", [_vm._v("Identificación del Cliente")]),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        label: "",
                        placeholder: "Por favor seleccione",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showTypePicker1 = true
                        },
                      },
                      model: {
                        value: _vm.pickerTypeValue1,
                        callback: function ($$v) {
                          _vm.pickerTypeValue1 = $$v
                        },
                        expression: "pickerTypeValue1",
                      },
                    }),
                  ],
                  1
                ),
                _vm.pickerTypeValue1 !== ""
                  ? [
                      _c("div", { staticClass: "select" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.columbiaForm.idNumber,
                              expression: "columbiaForm.idNumber",
                              modifiers: { trim: true },
                            },
                          ],
                          staticStyle: { color: "#333" },
                          attrs: {
                            type: "text",
                            maxlength:
                              _vm.pickerTypeValue1 === "Cédula de Identidad"
                                ? 10
                                : 6,
                            placeholder:
                              _vm.pickerTypeValue1 === "Cédula de Identidad"
                                ? "Por favor, introduzca 10 caracteres"
                                : "Por favor, introduzca 6 caracteres",
                          },
                          domProps: { value: _vm.columbiaForm.idNumber },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.columbiaForm,
                                "idNumber",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _c("div", { staticClass: "select" }, [
                  _c("span", [_vm._v("Cuenta beneficiaria")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.columbiaForm.accountId,
                        expression: "columbiaForm.accountId",
                        modifiers: { trim: true },
                      },
                    ],
                    staticStyle: { color: "#333" },
                    attrs: {
                      type: "number",
                      placeholder: "Ingrese un máximo de 10 dígitos",
                      maxlength: "10",
                    },
                    domProps: { value: _vm.columbiaForm.accountId },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.columbiaForm,
                            "accountId",
                            $event.target.value.trim()
                          )
                        },
                        (ev) => {
                          _vm.columbiaForm.accountId = ev.target.value.slice(
                            0,
                            10
                          )
                        },
                      ],
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("span", [_vm._v("Nombre del Banco")]),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        label: "",
                        placeholder: _vm.$t("lang.wd.bankName"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.showBankPicker = true
                        },
                      },
                      model: {
                        value: _vm.bankIndonesiaText,
                        callback: function ($$v) {
                          _vm.bankIndonesiaText = $$v
                        },
                        expression: "bankIndonesiaText",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _vm.withdrawalMethod == "Vodafone" ||
                _vm.withdrawalMethod == "Orange"
                  ? _c("div", { staticClass: "select" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("lang.wd.accountNameAr"))),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.accountName,
                            expression: "accountName",
                            modifiers: { trim: true },
                          },
                        ],
                        staticStyle: { color: "#333" },
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("lang.wd.accountNameArTip"),
                        },
                        domProps: { value: _vm.accountName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.accountName = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ])
                  : _vm.withdrawalMethod == "Paypal"
                  ? [
                      _c("div", { staticClass: "select" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.name")))]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.accountName,
                              expression: "accountName",
                              modifiers: { trim: true },
                            },
                          ],
                          staticStyle: { color: "#333" },
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.common.yourRealName"),
                          },
                          domProps: { value: _vm.accountName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountName = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("p", { staticClass: "paypal-tips" }, [
                        _vm._v(_vm._s(_vm.$t("lang.common.realNameTips"))),
                      ]),
                    ]
                  : _c("div", { staticClass: "select" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.name")))]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.accountName,
                            expression: "accountName",
                            modifiers: { trim: true },
                          },
                        ],
                        staticStyle: { color: "#333" },
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("lang.wd.phYourName"),
                        },
                        domProps: { value: _vm.accountName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.accountName = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                _c("div", { staticClass: "select" }, [
                  _vm.withdrawalMethod == "PIX"
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.accountPix")))])
                    : _vm.withdrawalMethod == "USDT" ||
                      _vm.withdrawalMethod == "USDT(BINANCE)"
                    ? _c("span", { attrs: { type: "text" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lang.wd.binanceAccount")) + " "
                        ),
                      ])
                    : _vm.withdrawalMethod == "USDT(TRC20)"
                    ? _c("span", { attrs: { type: "text" } }, [
                        _vm._v(_vm._s(_vm.$t("lang.wd.TRC20Account"))),
                      ])
                    : _vm.withdrawalMethod == "USDT(TRC20/BEP20)"
                    ? _c("span", { attrs: { type: "text" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("lang.wd.TRC20AccountCoinEX")) +
                            " (TRC20/BEP20)"
                        ),
                      ])
                    : _vm.withdrawalMethod == "Vodafone" ||
                      _vm.withdrawalMethod == "Orange"
                    ? _c("span", { attrs: { type: "text" } }, [
                        _vm._v(_vm._s(_vm.$t("lang.wd.accountNoAr"))),
                      ])
                    : _vm.withdrawalMethod == "Papara"
                    ? _c("span", { attrs: { type: "text" } }, [
                        _vm._v(_vm._s(_vm.$t("lang.wd.paparaAccountNo"))),
                      ])
                    : _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.phAccount")))]),
                  _c("div", { staticClass: "select-account" }, [
                    ["OVO", "DANA"].includes(_vm.withdrawalMethod)
                      ? _c("div", { staticClass: "PH-account arPhAccount" }, [
                          _vm._v("+62"),
                        ])
                      : _vm.withdrawalMethod == "GCash"
                      ? _c("div", { staticClass: "PH-account arPhAccount" }, [
                          _vm._v("+63"),
                        ])
                      : _vm._e(),
                    _vm.withdrawalMethod == "PIX"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "123.456.789-00",
                            onkeyup: "value=value.replace(/[^\\d.-]/g,'')",
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        })
                      : _vm.withdrawalMethod == "GCash"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "10",
                            oninput: "value=value.replace(/[^\\d]/g,'')",
                            placeholder: "GCash Account",
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        })
                      : _vm.withdrawalMethod == "USDT" ||
                        _vm.withdrawalMethod == "USDT(BINANCE)"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.wd.yourBinanceEmail"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        })
                      : _vm.withdrawalMethod == "USDT(TRC20)"
                      ? _c("div", { staticClass: "TRC20-box" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.accountId,
                                expression: "accountId",
                              },
                            ],
                            attrs: {
                              maxlength: "34",
                              type: "text",
                              placeholder: _vm.$t("lang.wd.TRC20Account"),
                            },
                            domProps: { value: _vm.accountId },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = $event.target.value
                              },
                            },
                          }),
                          _c("div", { staticClass: "TRC20-length-tip" }, [
                            _vm._v(_vm._s(_vm.accountId.length) + "/34"),
                          ]),
                        ])
                      : _vm.withdrawalMethod == "USDT(TRC20/BEP20)"
                      ? _c("div", { staticClass: "TRC20-box" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.accountId,
                                expression: "accountId",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              maxlength: "42",
                              type: "text",
                              placeholder: _vm.$t("lang.wd.TRC20AccountCoinEX"),
                            },
                            domProps: { value: _vm.accountId },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.accountId = $event.target.value.trim()
                                },
                                function ($event) {
                                  return _vm.filterNoNumerAndLetter(
                                    $event,
                                    "accountId"
                                  )
                                },
                              ],
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ])
                      : _vm.withdrawalMethod == "Paypal"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.wd.paypalTix"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        })
                      : _vm.withdrawalMethod == "Vodafone"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: { type: "text", maxlength: "11" },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = $event.target.value
                              },
                              _vm.validateInput,
                            ],
                            keypress: _vm.validateKeypress,
                            paste: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        })
                      : _vm.withdrawalMethod == "Orange"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "11",
                            placeholder: _vm.$t("lang.wd.accountNoArTip"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        })
                      : ["OVO", "DANA"].includes(_vm.withdrawalMethod) &&
                        _vm.locaCode === "ID"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "14",
                            placeholder: _vm.$t("lang.wd.accountNoArTipId"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = $event.target.value
                              },
                              _vm.onlyMaxLengthNumberFourteen,
                            ],
                          },
                        })
                      : _vm.withdrawalMethod === "DANA"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.wd.phAccount"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountId = $event.target.value
                              },
                              _vm.filterNonNumericChars,
                            ],
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountId,
                              expression: "accountId",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("lang.wd.phAccount"),
                          },
                          domProps: { value: _vm.accountId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.accountId = $event.target.value
                            },
                          },
                        }),
                  ]),
                  _vm.withdrawalMethod == "USDT(TRC20)"
                    ? _c("div", { staticClass: "tipTRC20" }, [
                        _c("div", [
                          _vm._v("* " + _vm._s(_vm.$t("lang.wd.TRC20Tip1"))),
                        ]),
                        _c("div", [
                          _vm._v("* " + _vm._s(_vm.$t("lang.wd.TRC20Tip2"))),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.withdrawalMethod == "USDT(TRC20/BEP20)"
                    ? _c("div", { staticClass: "tipTRC20-a" }, [
                        _vm._v(" * "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.binance.com/support/faq/detail/115003764971",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("lang.wd.binanceLink")))]
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm.withdrawalMethod === "Papara"
                  ? _c("div", { staticClass: "select" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("lang.wd.phoneNumber"))),
                      ]),
                      _c("div", { staticClass: "phone-number-wrapper" }, [
                        _c("span", { staticClass: "area-wrapper" }, [
                          _vm._v("+90"),
                        ]),
                        _c("div", { staticClass: "account-line" }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.userPhoneNumber,
                              expression: "userPhoneNumber",
                              modifiers: { number: true },
                            },
                          ],
                          attrs: {
                            type: "number",
                            placeholder: `${_vm.$t(
                              "lang.wd.phoneNumber"
                            )}（eg：1234567890）`,
                          },
                          domProps: { value: _vm.userPhoneNumber },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.userPhoneNumber = _vm._n(
                                  $event.target.value
                                )
                              },
                              _vm.onlyMaxLengthNumber10,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ])
                  : _vm._e(),
                _vm.withdrawalMethod === "USDT(BINANCE)"
                  ? [
                      _c("div", { staticClass: "select" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("lang.wd.address")) + " (TRC20/BEP20)"
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.accountAddress,
                              expression: "accountAddress",
                              modifiers: { trim: true },
                            },
                          ],
                          staticStyle: { color: "#333" },
                          attrs: {
                            maxlength: "42",
                            type: "text",
                            placeholder: _vm.$t("lang.wd.address"),
                          },
                          domProps: { value: _vm.accountAddress },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accountAddress = $event.target.value.trim()
                              },
                              function ($event) {
                                return _vm.filterNoNumerAndLetter(
                                  $event,
                                  "accountAddress"
                                )
                              },
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "tipTRC20-a" }, [
                        _vm._v(" * "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.binance.com/support/faq/detail/115003764971",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("lang.wd.binanceLink")))]
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
          _c(
            "div",
            {
              staticClass: "save-btn",
              class: { saveBtnAct: this.saveFlag() },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.cfgId ? _vm.$t("lang.change") : _vm.$t("lang.wd.save")
                  ) +
                  " "
              ),
            ]
          ),
        ],
        2
      ),
      _c(
        "van-dialog",
        {
          attrs: { "close-on-click-overlay": "true", showConfirmButton: false },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c("div", { staticClass: "pix-dialog" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.wd.pixDialogTitlt"))),
            ]),
            _c("div", { staticClass: "tip" }, [
              _vm._v(_vm._s(_vm.$t("lang.wd.pixDialogTip"))),
            ]),
            _c("div", { staticClass: "account" }, [_vm._v("123.456.789-00")]),
          ]),
        ]
      ),
      _c(
        "van-popup",
        {
          attrs: { "destroy-on-close": "", round: "", position: "bottom" },
          model: {
            value: _vm.showBankPicker,
            callback: function ($$v) {
              _vm.showBankPicker = $$v
            },
            expression: "showBankPicker",
          },
        },
        [
          _c("van-picker", {
            key: _vm.locaCode,
            attrs: {
              "show-toolbar": "",
              "cancel-button-text": _vm.$t("lang.cfm.cancelBtn"),
              "confirm-button-text": _vm.$t("lang.confirm"),
              "model-value": _vm.pickerValue,
              columns: _vm.bankList,
            },
            on: {
              cancel: function ($event) {
                _vm.showBankPicker = false
              },
              confirm: _vm.handleBankPickerConfirm,
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { "destroy-on-close": "", round: "", position: "bottom" },
          model: {
            value: _vm.showTypePicker1,
            callback: function ($$v) {
              _vm.showTypePicker1 = $$v
            },
            expression: "showTypePicker1",
          },
        },
        [
          _c("van-picker", {
            key: _vm.locaCode,
            attrs: {
              "show-toolbar": "",
              "cancel-button-text": _vm.$t("lang.cfm.cancelBtn"),
              "confirm-button-text": _vm.$t("lang.confirm"),
              "model-value": _vm.pickerTypeValue1,
              columns: _vm.columbiaList1,
            },
            on: {
              cancel: function ($event) {
                _vm.showTypePicker1 = false
              },
              confirm: _vm.handleTypePickerConfirm1,
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { "destroy-on-close": "", round: "", position: "bottom" },
          model: {
            value: _vm.showTypePicker2,
            callback: function ($$v) {
              _vm.showTypePicker2 = $$v
            },
            expression: "showTypePicker2",
          },
        },
        [
          _c("van-picker", {
            key: _vm.locaCode,
            attrs: {
              "show-toolbar": "",
              "cancel-button-text": _vm.$t("lang.cfm.cancelBtn"),
              "confirm-button-text": _vm.$t("lang.confirm"),
              "model-value": _vm.pickerTypeValue2,
              columns: _vm.columbiaList2,
            },
            on: {
              cancel: function ($event) {
                _vm.showTypePicker2 = false
              },
              confirm: _vm.handleTypePickerConfirm2,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }